export const DEFAULT_COLOR = '#000000'
